import React from 'react';
import { Link } from 'react-router-dom';
import { flixButton, flixUi } from '../styles/flixUiTheme';

function NotFoundPage() {
  return (
    <main
      style={{
        position: 'relative',
        minHeight: '100vh',
        color: flixUi.text,
        fontFamily: flixUi.fontFamily,
        overflow: 'hidden',
        display: 'grid',
        placeItems: 'center',
        padding: '1.5rem',
        background: '#000',
      }}
    >
      <style>{`
        .vf-404-video {
          object-fit: cover;
          object-position: center 46%;
          transform: scale(1.08);
        }

        .vf-404-video-shell {
          position: absolute;
          inset: 0;
          overflow: hidden;
        }

        .vf-404-content {
          transform: translateY(0);
        }

        @media (orientation: portrait), (max-aspect-ratio: 10/16) {
          .vf-404-video {
            object-fit: cover;
            object-position: center 40%;
            transform: scale(1.32);
          }

          .vf-404-video-shell {
            inset: 0;
          }

          .vf-404-content {
            transform: translateY(2vh);
          }
        }

        @media (max-width: 640px) {
          .vf-404-video {
            object-position: center 40%;
          }

          .vf-404-content {
            transform: translateY(3vh);
          }
        }

        @media (max-width: 1100px) {
          .vf-404-side-fill {
            display: none;
          }
        }
      `}</style>

      <div
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(110% 75% at 50% 40%, rgba(39, 71, 98, 0.46) 0%, rgba(12, 18, 28, 0.9) 58%, rgba(0,0,0,0.98) 100%)',
        }}
      />

      <div
        style={{
          position: 'absolute',
          inset: 0,
          opacity: 0.14,
          mixBlendMode: 'screen',
          backgroundImage:
            'radial-gradient(rgba(255,255,255,0.9) 0.5px, transparent 0.5px), radial-gradient(rgba(120,180,220,0.5) 0.4px, transparent 0.4px)',
          backgroundPosition: '0 0, 1px 1px',
          backgroundSize: '3px 3px, 4px 4px',
          pointerEvents: 'none',
        }}
      />

      <video
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
        className="vf-404-side-fill"
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: '-14%',
          width: '50%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center 46%',
          filter: 'blur(24px) brightness(0.5) saturate(0.75)',
          opacity: 0.5,
          transform: 'scaleX(-1)',
        }}
      >
        <source
          src="https://res.cloudinary.com/da1u9kl5f/video/upload/f_auto,q_auto/v1771811856/404_vintage-tv-glitch_vflfka"
          type="video/mp4"
        />
      </video>

      <video
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
        className="vf-404-side-fill"
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: '-14%',
          width: '50%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center 46%',
          filter: 'blur(24px) brightness(0.5) saturate(0.75)',
          opacity: 0.5,
        }}
      >
        <source
          src="https://res.cloudinary.com/da1u9kl5f/video/upload/f_auto,q_auto/v1771811856/404_vintage-tv-glitch_vflfka"
          type="video/mp4"
        />
      </video>

      <div className="vf-404-video-shell">
        <video
          autoPlay
          muted
          loop
          playsInline
          aria-hidden="true"
          className="vf-404-video"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
          }}
        >
          <source
            src="https://res.cloudinary.com/da1u9kl5f/video/upload/f_auto,q_auto/v1771811856/404_vintage-tv-glitch_vflfka"
            type="video/mp4"
          />
        </video>
      </div>

      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.32), rgba(0,0,0,0.5))',
        }}
      />

      <div
        style={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          background:
            'radial-gradient(ellipse at center, rgba(0,0,0,0) 30%, rgba(0,0,0,0.34) 63%, rgba(0,0,0,0.86) 100%)',
        }}
      />

      <section
        className="vf-404-content"
        style={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth: 860,
          textAlign: 'center',
        }}
      >
        <h1
          style={{
            fontSize: 'clamp(2rem, 6vw, 5rem)',
            fontWeight: flixUi.headingWeight,
            lineHeight: 1.05,
            letterSpacing: flixUi.titleLetterSpacing,
            marginBottom: '0.8rem',
          }}
        >
          Signal Lost.
        </h1>
        <p
          style={{
            color: 'rgba(255,255,255,0.9)',
            fontSize: 'clamp(1rem, 2.3vw, 1.55rem)',
            marginBottom: '1.8rem',
          }}
        >
          We couldn&apos;t find that page - but your memories are still waiting.
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '0.75rem',
            flexWrap: 'wrap',
          }}
        >
          <Link
            to="/"
            style={{
              ...flixButton,
              background: '#fff',
              color: '#000',
            }}
          >
            Veeflix Home
          </Link>
          <Link
            to="/login"
            style={{
              ...flixButton,
              background: 'rgba(255,255,255,0.18)',
              border: `1px solid ${flixUi.borderStrong}`,
              color: '#fff',
            }}
          >
            Login
          </Link>
        </div>
      </section>
    </main>
  );
}

export default NotFoundPage;
